import { render } from "./SimUserLimitMessage.vue?vue&type=template&id=8512edb2&scoped=true"
import script from "./SimUserLimitMessage.vue?vue&type=script&lang=js"
export * from "./SimUserLimitMessage.vue?vue&type=script&lang=js"

import "./SimUserLimitMessage.vue?vue&type=style&index=0&id=8512edb2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8512edb2"]])

export default __exports__